import { Expose } from 'class-transformer';

export default class User {
    @Expose() id: number = 0;
    @Expose() user_guid: string = "";
    @Expose() basket_id: string = "";
    @Expose() birthday: string = "";
    @Expose() cellNumber: string = "";
    @Expose() contact_number: string = "";
    @Expose() email: string = "";
    @Expose() email_address: string = "";
    @Expose() emailaddress: string = "";
    @Expose() first_name: string = "";
    @Expose() last_name: string = "";
    // @Expose() settings: HashMap<String, Boolean>?, OptionGroupInterface[] = [];
    @Expose() prompt_piada_gives_opt_in: boolean = false;
    @Expose() account_confirmed: boolean = false;

  constructor(
    id: number, 
    user_guid: string,
    basket_id: string,
    birthday: string,
    cellNumber: string,
    contact_number: string,
    email: string,
    email_address: string,
    emailaddress: string,
    first_name: string,
    last_name: string,
    prompt_piada_gives_opt_in: boolean,
    account_confirmed: boolean
    ) {
      this.id = id;
      this.user_guid = user_guid;
      this.basket_id = basket_id;
      this.birthday = birthday;
      this.cellNumber = cellNumber;
      this.contact_number = contact_number;
      this.email = email;
      this.email_address = email_address;
      this.emailaddress = emailaddress;
      this.first_name = first_name;
      this.last_name = last_name;
      this.prompt_piada_gives_opt_in = prompt_piada_gives_opt_in;
      this.account_confirmed = account_confirmed;
  }

  // getImageByKey = (key: string) => {
  //   if (this.images) {
  //     const keyedImages = this.images.filter(img => {
  //       return img.position == key
  //     })
  //     return keyedImages.length > 0 ? keyedImages[0] : null;
  //   } else {
  //     return null
  //   }
  // }

  // getMetaDataByKey = (key: string) => {
  //   let data = null;
  //   if (this.metadata) {
  //     data = this.metadata.find(md => {
  //       return md.key == key
  //     })
  //   }

  //   return data ? data.value : null;
  // }
}

